import { useContext, useEffect, useState } from "react";
import { AppsMenu, DashMenu, Header } from "../components";
import { AppContext, AppStateProps } from "../context/index";
import { SelectApplicationPage } from "./selectapplication/SelectApplicationPage";
import { useTenants } from "../hooks/useTenants";
import { useApplications } from "../hooks/useApplications";
import { auth } from "../services/iam/auth";

export const DashoardPage = () => {
  sessionStorage.removeItem('IS::FIRST::ENTRY')
  const {
    t,
    appState: { user, selectedTenantId, selectedApp, tenantId, childrenTenants },
    setAppState
  } = useContext(AppContext);

  useEffect(()=>{
    if (!selectedApp) {
      (async () => await auth.selectTenantAction(selectedTenantId ?? tenantId))();
    }
  },[selectedTenantId, selectedApp, tenantId]);

  const { data, reloadFn } = useTenants("TENANTID");
  const { getInfoApplicationsByTenant } = useApplications("APPS");
  const [infoApps, setInfoApps] = useState([]);

  useEffect(()=>{
    if (!!data && ((childrenTenants ?? []).length !== (data[0]?.childrenTenants ?? []).length)) {
      setAppState((prev:AppStateProps)=>({
        ...prev,
        childrenTenants: data[0]?.childrenTenants,
      }));
    };
    !!data && setAppState((prev:AppStateProps)=>({
      ...prev,
      aliasParentTenant: data[0]?.alias ?? '',
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[data]);

  useEffect(() => {
    const getInfo = async () => {
      const res = await Promise.resolve(getInfoApplicationsByTenant(selectedTenantId ? selectedTenantId : tenantId));
      setInfoApps(res);
    }
    getInfo();
    !data && reloadFn();
  }, [data, selectedTenantId]);

  useEffect(() => {
    sessionStorage.removeItem('filters-table');
  }, []);

  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}

      {
        data !== null && !selectedTenantId
          ? <AppsMenu data={data} apps={infoApps?.length > 0 ? infoApps : undefined} setInfoApps={setInfoApps} /> 
          : (selectedTenantId && !selectedApp) 
            ? <SelectApplicationPage /> 
            : (selectedApp) && <DashMenu /> 
      }
    </>
  );
};
